/* tslint:disable */
/* eslint-disable */
/**
 * BS2
 * BoostSales 2
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UserProjection
 */
export interface UserProjection {
    /**
     * 
     * @type {number}
     * @memberof UserProjection
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof UserProjection
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof UserProjection
     */
    email?: string;
}

/**
 * Check if a given object implements the UserProjection interface.
 */
export function instanceOfUserProjection(value: object): value is UserProjection {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function UserProjectionFromJSON(json: any): UserProjection {
    return UserProjectionFromJSONTyped(json, false);
}

export function UserProjectionFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserProjection {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'email': json['email'] == null ? undefined : json['email'],
    };
}

export function UserProjectionToJSON(json: any): UserProjection {
    return UserProjectionToJSONTyped(json, false);
}

export function UserProjectionToJSONTyped(value?: UserProjection | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'email': value['email'],
    };
}

